import get from 'lodash/get'
import request from '../../request'
import { createAuthorization } from '../../auth'

/**
 * Get merchandising campaigns from brooklyn
 */
export async function getPlacements ({ auth, server }) {
  const res = await request
    .get(`${server}/admin/merchandising/placements`)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
  return get(res, 'body', {})
}

export async function getDateRangeValues ({ auth, server }) {
  const res = await request
    .get(`${server}/admin/merchandising/date-range-filter-values`)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
  return get(res, 'body', {})
}
